import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const YoutubeWrap = styled.div`
  position: absolute;
  width: 88.33%;
  height: 36.82%;
  top: 57.49%;
  left: 5.83%;
  > div {
    width: 100%;
    height: 100%;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const Btn = styled.button`
  position: absolute;
  top: 42.24%;
  left: 21.91%;
  width: 56.33%;
  height: 10.13%;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;
